import { MarketEmptyState } from '@market/react';
import { useTranslation } from 'react-i18next';
import styles from './EmptyState.module.css';

export const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <MarketEmptyState className={styles.noResult}>
      <h3 slot="primary-text">{t('bankingShared.locationSelector.emptyState.title')}</h3>
      <p className="paragraph-30" slot="secondary-text">{t('bankingShared.locationSelector.emptyState.body')}</p>
    </MarketEmptyState>
  );
};
